import { useId } from 'react';

/**
 * Label + input + optional hint/error, wired up for screen readers.
 *   optional  adds "(optional)" to the label — we mark the optional fields, not the
 *             required ones, so most labels stay short
 *   counter   with maxLength: shows "120 / 1000" under the field once it's in use
 */
export default function Field({ label, hint, error, optional = false, counter = false, as = 'input', children, ...props }) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errId = error ? `${id}-err` : undefined;
  const Tag = as;
  const length = typeof props.value === 'string' ? props.value.length : 0;
  const showCounter = counter && props.maxLength && length > 0;
  return (
    <div className="field">
      <label htmlFor={id}>{label}{optional && <span className="field-optional"> (optional)</span>}</label>
      <Tag id={id} aria-describedby={[hintId, errId].filter(Boolean).join(' ') || undefined}
        aria-invalid={error ? 'true' : undefined} {...props}>
        {children}
      </Tag>
      {hint && <p id={hintId} className="field-hint">{hint}</p>}
      {error && <p id={errId} className="field-error" role="alert">{error}</p>}
      {showCounter && <p className={`field-counter${length > props.maxLength * 0.9 ? ' is-near' : ''}`} aria-live="polite">{length} / {props.maxLength}</p>}
    </div>
  );
}
